export enum UserByEnum {
  BUY_COIN = 'BUY_COIN',
  REDEEM = 'REDEEM',
}

export const UserByTypeValue = {
  [UserByEnum.BUY_COIN]: 'coin',
  [UserByEnum.REDEEM]: 'redeem code',
}
